import { gql } from '@apollo/client';
const UPDATE_MODEL = gql `
  mutation UpdateModel(
    $brandId: ID
    $categoryId: ID
    $itemCode: String
    $fancyName: String
    $description: String
    $statusId: ID
    $clearStatus: Boolean
    $modelSpecificationId: ID!
    $seasonId: ID
    $productionTimeMinutes: Int
  ) {
    updateModelSpecification(
      brandId: $brandId
      categoryId: $categoryId
      itemCode: $itemCode
      fancyName: $fancyName
      modelSpecificationId: $modelSpecificationId
      description: $description
      statusId: $statusId
      clearStatus: $clearStatus
      seasonId: $seasonId
      productionTimeMinutes: $productionTimeMinutes
    ) {
      modelSpecification {
        id
        itemCode
        fancyName
        description
        productionTimeMinutes
        brand {
          id
          name
        }
        category {
          id
          name
        }
        sizeStandard {
          id
          name
        }
        season {
          id
          name
        }
        status {
          id
          namePL
          nameEN
          color
        }
      }
    }
  }
`;
export default UPDATE_MODEL;
